var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52758 1.3912C4.51584 1.3912 1.26367 4.64339 1.26367 8.65511C1.26367 15.919 9.84829 22.5226 14.4708 24.0587C19.0933 22.5226 27.6779 15.919 27.6779 8.65511C27.6779 4.64339 24.4257 1.3912 20.414 1.3912C17.9573 1.3912 15.7853 2.61082 14.4708 4.47757C13.1562 2.61082 10.9843 1.3912 8.52758 1.3912Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.57768,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f00f2bdaeec51907eaa21716b54b22ae.svg";
export { ForwardRef as ReactComponent };